<template>
  <div class="index">
    <el-container>
      <el-main>
        <div class="main">
          <!-- 左侧备选组件区 -->
          <div class="main-left">
            <form-item-config></form-item-config>
          </div>
          <!-- 中间内容区 -->
          <div class="main-middle">
            <!-- 顶部按钮 -->
            <div class="button-top">
              <index-button-group 
                @submit="saveTemplate"
                @saveDomain="saveDomain">
              </index-button-group>
            </div>
            <!-- 拖拽区域 -->
            <div class="drop-wrap">
              <form-draggable-container></form-draggable-container>
            </div>
          </div>
          <!-- 右侧属性设置区 -->
          <div class="main-right">
            <form-item-setting></form-item-setting>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
const packageConfig = require('../../../package.json');
/** 混入方法 ::: 
 *  @mixin mixFormMakeStore 表单编辑组件父级混入
 */
import { mixRiceIndex } from "@/mixins/rice_index/mix_rice_index.js";
/** 工具方法 :::
 *  @function upgrade 配置升级方法
 */
import { upgrade } from "@/assets/version/version.js";


/** @name 模版编辑组件
 *  @param {Object} templateConfig 模版数据
 *  - {Array} domainList 模块组件列表
 *  - {Array} formList 表单组件列表, 
 *  - {Object} formMap 表单字典表, 
 *  - {Object} eventMap 事件字典表
 *  @param {String} itemManage 拓展功能
 *  @event refurbishConfig 刷新模版数据 v-model刷新
 *  @event getFormInfo 提交模版数据 
 */
export default {
  name: 'RiceIndex',
  mixins: [ mixRiceIndex ],
  provide() { return { itemManage:this.itemManage } }, 
  model: {
    prop: 'templateConfig',
    event: 'refurbishConfig'
  },
  props: {
    /** 模版配置 { version:版本号, itemManage:扩展功能, domainList:分组列表, formList:表单列表, formMap:表单项字典, eventMap:事件字典 } **/
    templateConfig: {
      type: Object,
      default: () => ({})
    },
    /** 拓展功能 { group:"启用分组管理" } **/
    itemManage: {
      type: String,
      default: "group"
    }
  },
  methods: {
    /** @name 保存模块组件
     *  @description 更新使用者模块组件数据
     *  @author 王汝鹏
     *  @version 2019-10-06
     */
    saveDomain() {
      // 向外传递设置的表单信息
      this.$emit('refurbishConfig', this.freshTemplateConfig);
    },
    /** @name 提交模版
     *  @description 传出合同模版数据给使用者
     *  @author 王汝鹏
     *  @version 2019-09-28
     */
    saveTemplate() {
      // 打印将要传出的模版数据
      console.log(this.freshTemplateConfig)
      // 向外传递设置的表单信息
      this.$emit('getFormInfo', this.freshTemplateConfig);
    }
  },
  computed: {
    /** @name 提交模版配置数据
     *  @return {Object} 最新的模版数据
     *  @author 王汝鹏
     *  @version 2019-12-25
     */
    freshTemplateConfig() {
      return {
        version: packageConfig.version,
        itemManage: this.itemManage,
        domainList: this.domainList,
        formList: this.formList,
        formMap: this.formMap,
        eventMap: this.eventMap,
        variableMap: this.variableMap
      }
    }
  },
  watch: {
    /** @name 模版配置数据
     *  @description 外部传入模版数据变化时，更新store中的数据
     */
    templateConfig: {
      handler(newValue) {
        // 升级传入的配置
        let upgradeValue = {};
        try {
          upgradeValue = upgrade(newValue);
          // 更新数据到store中
          this.importTemplateConfig(upgradeValue);
          // console.log('配置升级:: ', newValue, upgradeValue);
        } catch(error) {
          // console.log("配置升级错误:: ",  newValue);
        }
      },
      immediate: true
    },
    /** @name 扩展功能
     *  @description {none:"不启用扩展功能", group:"启用分组管理功能"}
     */
    itemManage: {
      handler(newValue) { this.expandFunction = newValue; },
      immediate: true
    },
    /** @name 模块组件列表
     *  @description 当模块组件列表发生改变时，触发刷新模块组件列表模版事件(合同业务用于刷新token)
     */
    domainList: {
      handler(newValue) { this.$emit('refurbishConfig', this.freshTemplateConfig); },
    }
  }
}
</script>
<style lang="scss">
@import "../../../src/style/index.scss";
</style>


// WEBPACK FOOTER //
// packages/RiceIndex/src/RiceIndex.vue